import { api } from './api'
import { throwApiError } from './apiHelpers'

function assertSuccess(body: unknown) {
  const b = body as { success?: boolean; message?: string; data?: unknown }
  if (!b?.success) {
    throw new Error(b?.message || 'Request failed')
  }
  return b.data
}

export type SuperAdminTeamRow = {
  id: number
  email: string
  firstName: string
  lastName: string
  name: string
  adminScope: 'FREE' | 'PAID' | 'ALL'
  createdAt: string
  updatedAt: string
}

export async function listSuperAdmins(): Promise<{ items: SuperAdminTeamRow[] }> {
  try {
    const { data } = await api.get('/admin/super-admins')
    return assertSuccess(data) as { items: SuperAdminTeamRow[] }
  } catch (e) {
    throwApiError(e, 'Failed to load platform team')
  }
}

export async function createSuperAdmin(payload: {
  email: string
  firstName: string
  lastName: string
  adminScope?: 'FREE' | 'PAID' | 'ALL'
}): Promise<SuperAdminTeamRow> {
  try {
    const { data } = await api.post('/admin/super-admins', payload)
    return assertSuccess(data) as SuperAdminTeamRow
  } catch (e) {
    throwApiError(e, 'Failed to invite platform operator')
  }
}

export async function resetSuperAdminCredentials(id: number) {
  try {
    const { data } = await api.post(`/admin/super-admins/${id}/reset-credentials`)
    return assertSuccess(data) as { id: number; emailSent: boolean }
  } catch (e) {
    throwApiError(e, 'Failed to reset credentials')
  }
}

export async function deactivateSuperAdmin(id: number) {
  try {
    const { data } = await api.delete(`/admin/super-admins/${id}`)
    return assertSuccess(data) as { id: number; deactivated: boolean }
  } catch (e) {
    throwApiError(e, 'Failed to deactivate platform operator')
  }
}
